module.exports = __webpack_public_path__ + "static/img/fill2@2x.1a7402b0.png";